import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE || '',
  withCredentials: true,
});

let accessToken = null;
let onUnauthorized = null;
let refreshPromise = null;
const refreshHandlers = { run: null };

export function setAccessToken(token) {
  accessToken = token;
}

export function getAccessToken() {
  return accessToken;
}

export function setUnauthorizedHandler(fn) {
  onUnauthorized = fn;
}

export function setRefreshHandler(fn) {
  refreshHandlers.run = fn;
}

api.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

const RETRY_FLAG = '__intek_retry';
const REFRESH_PATH = '/api/auth/refresh';

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const { response, config } = error;
    if (!response || response.status !== 401 || !config) {
      return Promise.reject(error);
    }
    if (config[RETRY_FLAG]) {
      if (onUnauthorized) onUnauthorized();
      return Promise.reject(error);
    }
    if (config.url && config.url.includes(REFRESH_PATH)) {
      if (onUnauthorized) onUnauthorized();
      return Promise.reject(error);
    }

    config[RETRY_FLAG] = true;

    if (!refreshPromise) {
      refreshPromise = (async () => {
        try {
          if (!refreshHandlers.run) throw new Error('no refresh handler');
          await refreshHandlers.run();
        } finally {
          refreshPromise = null;
        }
      })();
    }

    try {
      await refreshPromise;
    } catch (e) {
      if (onUnauthorized) onUnauthorized();
      return Promise.reject(e);
    }

    if (accessToken) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return api(config);
  }
);

export default api;
